/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_viewer = {
    readonly isRequestMoreImagesEnabled: boolean | null;
    readonly videoUploadToolsFeatureFlag: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubblesWrapper_viewer">;
    readonly " $refType": "PdpRespHeroCarousel_viewer";
};
export type PdpRespHeroCarousel_viewer$data = PdpRespHeroCarousel_viewer;
export type PdpRespHeroCarousel_viewer$key = {
    readonly " $data"?: PdpRespHeroCarousel_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarousel_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarousel_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isRequestMoreImagesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REQUEST_MORE_IMAGES"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"REQUEST_MORE_IMAGES\")"
    },
    {
      "kind": "ScalarField",
      "alias": "videoUploadToolsFeatureFlag",
      "name": "featureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "videoUploadTools"
        }
      ],
      "storageKey": "featureFlag(feature:\"videoUploadTools\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '80ec0777caba4c4bb62c53557865dd49';
export default node;
